export const SET_PROVIDER_ACTION = "SET_PROVIDER_ACTION";

export function setProviderAction(data) {
  return {
    type: SET_PROVIDER_ACTION,
    data: { data },
  };
}
